import { render, staticRenderFns } from "./formInstagram.vue?vue&type=template&id=6c5a9967&"
import script from "./formInstagram.vue?vue&type=script&lang=js&"
export * from "./formInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports